/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
import React, { useEffect } from "react";
import styles from "./styles.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper/modules";
import { IMAGE_URL_v4 } from "../../../../envs/prod/constants";
import CustomNextImage from "../Common/CustomNextImage";

export default function CreatorComponent({ windowSize }) {
  const creatorData = [
    {
      id: 0,
      creatorname: "Nitish Rajput",
      creatorImage: `${IMAGE_URL_v4}/creators/nitish_rajput_v1.webp`,
      category: "Success Guru",
      color: "#FF6433",
    },
    {
      id: 1,
      creatorname: "Hawa Singh",
      creatorImage: `${IMAGE_URL_v4}/creators/4.webp`,
      category: "Youtube Guru",
      color: "#00BC35",
    },
    {
      id: 2,
      creatorname: "Padmini Thampi",
      creatorImage: `${IMAGE_URL_v4}/creators/3.webp`,
      category: "Success Guru",
      color: "#E440FF",
    },
    {
      id: 3,
      creatorname: "Nikhil Verma",
      creatorImage: `${IMAGE_URL_v4}/creators/5.webp`,
      category: "Stock Market Guru",
      color: "#00BCBC",
    },
    {
      id: 4,
      creatorname: "Ankit Pareek",
      creatorImage: `${IMAGE_URL_v4}/creators/1.webp`,
      category: "Business Guru",
      color: "#FF6433",
    },
    {
      id: 5,
      creatorname: "Avinash Jha",
      creatorImage: `${IMAGE_URL_v4}/creators/2.webp`,
      category: "Online Business Guru",
      color: "#D7DA3D",
    },
    {
      id: 6,
      creatorname: "Onish",
      creatorImage: `${IMAGE_URL_v4}/creators/6.webp`,
      category: "Finance Guru",
      color: "#EC33B8",
    },
    {
      id: 7,
      creatorname: "Shahnawaz Alam",
      creatorImage: `${IMAGE_URL_v4}/creators/8.webp`,
      category: "Online Earning Guru",
      color: "#23EC7F",
    },
    {
      id: 8,
      creatorname: "Naushad",
      creatorImage: `${IMAGE_URL_v4}/creators/7.webp`,
      category: "Technology Guru",
      color: "#EC33B8",
    },
  ];

  const scrollToContent = () => {
    const element = document.getElementById("form_creator");
    element?.scrollIntoView({
      behavior: "smooth",
      block: "end",
      inline: "nearest",
    });
  };

  return windowSize >= 768 ? (
    <div className={styles.creator_wrapper_column}>
      {/* <div className={styles.creator_wrapper_desk}>
        <div className={styles.creator_left_desk}>
          <div className={styles.creator_topics_create_desk}>Create</div>
          <div className={styles.creator_topics_title_desk}>
            Share what you know through short video series
          </div>
          <div className={styles.creator_topics_desc_desk}>
            Create bite sized videos in your field of expertise and share them
            as short video series
          </div>
          <div className={styles.subscribetoplus}>
            <a
              className={styles.start_learning}
              onClick={() => scrollToContent()}
            >
              Become a Creator
              <img
                alt="seekho"
                src="assets/longArrow.svg"
                className={styles.img_google}
              />
            </a>
          </div>
        </div>
        <div className={styles.creator_topics_img}>
          <img alt="seekho" src={`${IMAGE_URL_v4}/home/GroupMobile.webp`} />
        </div>
      </div> */}
      {/* <div className={styles.creator_wrapper_desk_earn}>
        <div className={styles.creator_left_desk}>
          <div className={styles.creator_topics_earn_desk}>Earn</div>
          <div className={styles.creator_topics_title_desk}>
            Get paid to do what you love!
          </div>
          <div className={styles.creator_topics_desc_desk}>
            Monetize your creations and get paid for every series you create and
            publish on Seekho
          </div>
          <div className={styles.subscribetoplus}>
            <a
              className={styles.start_learning}
              onClick={() => scrollToContent()}
            >
              Start earning
              <img
                alt="seekho"
                src="assets/longArrow.svg"
                className={styles.img_google}
              />
            </a>
          </div>
        </div>
        <div className={styles.creator_topics_img}>
          <img alt="seekho" src={`${IMAGE_URL_v4}/home/Creatormoney.webp`} />
        </div>
      </div> */}
      {/* <div className={styles.creator_wrapper_desk}>
        <div className={styles.creator_left_desk}>
          <div className={styles.creator_topics_grow_desk}>GROW</div>
          <div className={styles.creator_topics_title_desk}>
            Take your niche to the next level and expand your audience
          </div>
          <div className={styles.creator_topics_desc_desk}>
            Our best-in-class content team helps you grow as a creator
          </div>
          <div className={styles.subscribetoplus}>
            <a
              className={styles.start_learning}
              onClick={() => scrollToContent()}
            >
              Grow with Seekho
              <img
                alt="seekho"
                src="assets/longArrow.svg"
                className={styles.img_google}
              />
            </a>
          </div>
        </div>
        <div className={styles.creator_topics_img}>
          <img alt="seekho" src={`${IMAGE_URL_v4}/home/Creatorgrowth.webp`} />
        </div>
      </div> */}
      <div className={styles.creator_wrapper_scroll}>
        <div className={styles.creator_wrapper_scroll_title}>
          Top Seekho Gurus
        </div>
        <div>
          {/* <Swiper
          centeredSlides={true}
          slidesPerView={3}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: false,
          }}
          navigation={true}
          modules={[Autoplay, Navigation]}
          loop={false}
          initialSlide={5}          
          style={{height: "100%", marginTop: 60}}
          className="mySwiper"
        >
          {[...creatorData,...creatorData]?.map((data, index) =>
          <SwiperSlide className={styles.slide_creator} key={index}>
            <div className={styles.background}>
              <img src={data.creatorImage} className={styles.background_img}/>
            </div>
            <div className={styles.background_bottom}>
              <svg xmlns="http://www.w3.org/2000/svg" width="175" height="98" viewBox="0 0 175 98" fill="none">
              <g filter="url(#filter0_d_13891_14820)">
              <path d="M3.46875 0.26947C3.46875 0.26947 30.5417 17.6021 87.5542 17.6021C144.567 17.6021 172.277 0.26947 172.277 0.26947V91.999H3.46875V0.26947Z" fill="url(#paint0_linear_13891_14820)" shape-rendering="crispEdges"/>
              </g>
              <defs>
              <filter id="filter0_d_13891_14820" x="0.920707" y="0.26947" width="173.905" height="96.8256" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
              <feOffset dy="2.54804"/>
              <feGaussianBlur stdDeviation="1.27402"/>
              <feComposite in2="hardAlpha" operator="out"/>
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_13891_14820"/>
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_13891_14820" result="shape"/>
              </filter>
              <linearGradient id="paint0_linear_13891_14820" x1="87.5542" y1="-42.0917" x2="87.5542" y2="106.013" gradientUnits="userSpaceOnUse">
              <stop stop-color="white" stop-opacity="0.05"/>
              <stop offset="0.216667" stop-color="white" stop-opacity="0.0716688"/>
              <stop offset="0.9999" stop-color="white" stop-opacity="0.15"/>
              <stop offset="1" stop-color="white" stop-opacity="0.15"/>
              </linearGradient>
              </defs>
              </svg>
              <div className={styles.background_bottom_data}>
                <div className={styles.background_bottom_name}>{data.creatorname}</div>
                <div className={styles.background_bottom_category} style={{ color: data.color}}>{data.category}</div>
              </div>
            </div>
          </SwiperSlide>
          )}
        </Swiper> */}
        </div>
        <Swiper
          centeredSlides={true}
          slidesPerView={"auto"}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: false,
          }}
          navigation={true}
          modules={[Autoplay, Navigation]}
          loop={true}
          initialSlide={5}
          style={{ height: "100%", marginTop: 60 }}
          className="mySwiper"
        >
          {[...creatorData, ...creatorData]?.map((data, index) => (
            <SwiperSlide className={styles.slide_creator} key={index}>
              <div className={styles.background}>
                <img
                  alt={data.creatorname}
                  src={data.creatorImage}
                  className={styles.background_img}
                />
              </div>
              <div className={styles.background_bottom}>
                <div className={styles.background_bottom_data}>
                  <div className={styles.background_bottom_name}>
                    {data.creatorname}
                  </div>
                  <div
                    className={styles.background_bottom_category}
                    style={{ color: data.color }}
                  >
                    {data.category}
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      {/* <div className={styles.subscribetoplus}>
        <a className={styles.start_learning} onClick={() => scrollToContent()}>
          Join Seekho
          <img
            alt="seekho"
            src="assets/longArrow.svg"
            className={styles.img_google}
          />
        </a>
      </div> */}
    </div>
  ) : (
    <div>
      <div className={styles.creator_wrapper_scroll}>
        <div className={styles.creator_wrapper_scroll_title}>
          Top Seekho Gurus
        </div>
        <div>
          <Swiper
            centeredSlides={true}
            loop={true}
            slidesPerView={"auto"}
            spaceBetween={10}
            initialSlide={2}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: false,
            }}
            navigation={false}
            modules={[Autoplay]}
            style={{ height: "100%" }}
            className="mySwiper"
          >
            {creatorData?.map((data, index) => (
              <SwiperSlide className={styles.slide_creator} key={index}>
                <div className={styles.background}>
                  <CustomNextImage
                    src={data.creatorImage}
                    alt="seekho"
                    priority={true}
                    width={100}
                    height={128}
                    className={styles.background_img}
                  />
                </div>
                <div className={styles.background_bottom}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="175"
                    height="98"
                    viewBox="0 0 175 98"
                    fill="none"
                  >
                    <g filter="url(#filter0_d_13891_14820)">
                      <path
                        d="M3.46875 0.26947C3.46875 0.26947 30.5417 17.6021 87.5542 17.6021C144.567 17.6021 172.277 0.26947 172.277 0.26947V91.999H3.46875V0.26947Z"
                        fill="url(#paint0_linear_13891_14820)"
                        shape-rendering="crispEdges"
                      />
                    </g>
                    <defs>
                      <filter
                        id="filter0_d_13891_14820"
                        x="0.920707"
                        y="0.26947"
                        width="173.905"
                        height="96.8256"
                        filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB"
                      >
                        <feFlood
                          flood-opacity="0"
                          result="BackgroundImageFix"
                        />
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha"
                        />
                        <feOffset dy="2.54804" />
                        <feGaussianBlur stdDeviation="1.27402" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                        />
                        <feBlend
                          mode="normal"
                          in2="BackgroundImageFix"
                          result="effect1_dropShadow_13891_14820"
                        />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="effect1_dropShadow_13891_14820"
                          result="shape"
                        />
                      </filter>
                      <linearGradient
                        id="paint0_linear_13891_14820"
                        x1="87.5542"
                        y1="-42.0917"
                        x2="87.5542"
                        y2="106.013"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="white" stop-opacity="0.05" />
                        <stop
                          offset="0.216667"
                          stop-color="white"
                          stop-opacity="0.0716688"
                        />
                        <stop
                          offset="0.9999"
                          stop-color="white"
                          stop-opacity="0.15"
                        />
                        <stop
                          offset="1"
                          stop-color="white"
                          stop-opacity="0.15"
                        />
                      </linearGradient>
                    </defs>
                  </svg>
                  <div className={styles.background_bottom_data}>
                    <div className={styles.background_bottom_name}>
                      {data.creatorname}
                    </div>
                    <div
                      className={styles.background_bottom_category}
                      style={{ color: data.color }}
                    >
                      {data.category}
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
      {/* <div className={styles.subscribetoplus}>
        <a className={styles.start_learning} onClick={() => scrollToContent()}>
          Join Seekho
          <img
            alt="seekho"
            src="assets/longArrow.svg"
            className={styles.img_google}
          />
        </a>
      </div> */}
      <div className="mb-14 -mt-5">
        <h6 className="text-[30px] font-semibold text-center font-inter lg:text-[40px]">
          200+ Experts
        </h6>
        <h6 className="text-[15px] font-normal text-center tracking-wide mt-3 lg:text-[16px]">
          Real Life Gurus, Real Gyaan
        </h6>
      </div>
    </div>
  );
}
